import { io } from 'socket.io-client';
import config from '@/config';
import { getAccessToken } from '@/api/tokenStorage';

let socket = null;
let publicSocket = null;

export const connectSocket = () => {
  const token = getAccessToken();

  if (socket) {
    socket.auth = { token };
    if (!socket.connected && token) {
      socket.connect();
    }
    return socket;
  }

  socket = io(config.socketUrl, {
    autoConnect: Boolean(token),
    withCredentials: true,
    transports: ['websocket', 'polling'],
    auth: { token },
  });

  return socket;
};

export const updateSocketAuth = (token) => {
  if (!socket) return;
  socket.auth = { token };
  if (token && !socket.connected) {
    socket.connect();
  }
  if (!token && socket.connected) {
    socket.disconnect();
  }
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const connectPublicSocket = () => {
  if (publicSocket) {
    if (!publicSocket.connected) {
      publicSocket.connect();
    }
    return publicSocket;
  }

  publicSocket = io(config.socketUrl, {
    autoConnect: true,
    withCredentials: true,
    transports: ['websocket', 'polling'],
  });

  return publicSocket;
};

export const getPublicSocket = () => publicSocket;

export const disconnectPublicSocket = () => {
  if (publicSocket) {
    publicSocket.disconnect();
    publicSocket = null;
  }
};
